import { TimelineLite, Power0, Power3, Back} from 'gsap';

const animation = (audioFn) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.replay-section'], {pointerEvents: 'none'})
        .from('.claim-process__heading', .8, {alpha: 0, ease: Power0.easeNone, delay: .3 })
        .from('.claim-process__content p:first-of-type', .8, {alpha: 0, ease: Power0.easeNone, delay: .3})
        .staggerFrom('.claim-process__content ul li', .8, {alpha: 0, ease: Power0.easeNone, delay: .5}, 0.6)
        .from('.claim-process__content p:last-of-type', .8, {alpha: 0, ease: Power0.easeNone, delay: .5})
        .from('#gray-paper-with-shadow', .8, {alpha: .5, y: '+=100%', transformOrigin:"50% 100%"}, '+=0.5')
        .staggerFrom('.gray-text', .8, {scaleX: 0, alpha: .5, ease: Back.easeOut.config(.5)}, '.5')
        .from('#blue-dot', .8, {alpha: 0.7, scale: 0, ease: Power3.easeOut, transformOrigin:"50% 50%"}, '+=0.5')
        .from(['#persons-head', '#persons-body'], 1, {y: '+=150'}, '+=0.5')
        .set('.replay-section', {pointerEvents: 'auto'}, '+=.3')
        .from('.replay-section', .8, {alpha: 0, delay: 0.5, ease: Power0.easeNone})
} 

export default animation